import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'fin-date',
  templateUrl: './date.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DateComponent {
  @Input()
  date = 0;

  @Input()
  text = '';

  constructor() {
    /* noop */
  }
}
